import { store } from '../redux/store';
import { displayError, displayErrorString, handleUnauthorized} from '../api-utilities/api-calls';
import { getAccessToken, getAuth, getUserInfo } from '../security/authStorage';
import { IUserInfo } from '../interfaces/interfaces';
import { updateReduxAction } from '../redux/actions';
import { normalizeBasisOfDesign } from '../utilities/basisOfDesignOptions';
//This file contains calls to the Lowry backend, which gets results from the ProjectDataAPI

const apibase = process.env.REACT_APP_CLIENT_API;
const MAX_FACTORY_REQUEST_ATTACHMENT_SIZE_MB = 50;

export async function getAuthToken() {
  return getAccessToken();
}
export async function GetFreightStatesCheckPostalCode(postalCode: any) {
  const token = await getAuthToken();
  try {
    const result = await fetch(apibase + '/dataapi/getFreightStatesCheckPostalCode/' + postalCode, {
      method: 'get',
      headers: { Authorization: `Bearer ${token}` }
    });
    if (result.status === 200) {
      const data = await result.json();
      if (data.hasError){
        displayErrorString(data.errorMessage, "getFreightStatesCheckPostalCode");
      }
      return data;
    }
    else{
      if (!handleUnauthorized(result.status, 'getFreightStatesCheckPostalCode')) {
        displayErrorString("Requst failed", 'getFreightStatesCheckPostalCode');
      }
    }
  } catch (error) {
    displayError(error, 'getFreightStatesCheckPostalCode');
  }  
}
export async function getProjectsByUser() {
  const token = await getAuthToken();
  try {
    const result = await fetch(apibase + '/dataapi/getProjectsByUser', {
      method: 'get',
      headers: { Authorization: `Bearer ${token}` }
    });
    if (result.status === 200) {
      const data = await result.json();
      if (data.hasError){
        displayErrorString(data.errorMessage, "getAllProjects");
      }
      return data;
    }
    else{
      if (!handleUnauthorized(result.status, 'getAllProjects')) {
        displayErrorString("Requst failed", 'getAllProjects');
      }
    }
  } catch (error) {
    displayError(error, 'getAllProjects');
  }
}

export async function getProject(projectId:string) {
  const token = await getAuthToken();
  let source = "";
  let url = "";

  url = apibase + '/dataapi/getProject/'+ projectId;
  source = "getProject";

  const result = await fetch(url, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });

  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, source);
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, source)) {
      displayErrorString("Requst failed", source);
    }
  }
}

export async function getProjectProStatus(projectId:string) {
  const token = await getAuthToken();
  let source = "";
  let url = "";

  url = apibase + '/dataapi/getProjectProStatus/'+ projectId;
  source = "getProjectProStatus";

  const result = await fetch(url, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });

  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, source);
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, source)) {
      displayErrorString("Requst failed", source);
    }
  }
}

export async function getStatusTypes() {
  const token = await getAuthToken();
try{
  const result = await fetch(apibase + '/dataapi/getEnumValues/100', {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getEnumValues(100)");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, "getEnumValues(100)")) {
      displayErrorString("Requst failed", "getEnumValues(100)");
    }
  }
}
catch{
  console.log("request failed: getEnumValues(100)");
  displayErrorString("Requst failed", "getEnumValues(100)");
  let response:any = {
    enumDtoList: []
  };
  return response;
}
}
//Called from update project (to database).  This method updates redux.
function updateSelectedProject(project:any){
  
  let selectedProject = { ...store.getState().reduxProjectManagement.selectedProject};
  const designBasis = normalizeBasisOfDesign(project.designBasis ?? selectedProject.designBasis);
    
  selectedProject.projectName = project.projectName ?? selectedProject.projectName;
  selectedProject.consultingEngineer = project.consultingEngineer ?? selectedProject?.consultingEngineer;
  selectedProject.contractor = project.contractor ?? selectedProject?.contractor;
  selectedProject.city = project.city ?? selectedProject.city;
  selectedProject.state = project.state ?? selectedProject.state;
  selectedProject.projectId = project.id ?? selectedProject.projectId;
  selectedProject.jobPhase = project.jobPhase ?? selectedProject.jobPhase;
  selectedProject.projectType = project.projectType ?? selectedProject.projectType;
  selectedProject.constructionType = project.constructionType ?? selectedProject.constructionType;
  selectedProject.designBasis = designBasis;
  selectedProject.purchaseOrderNumber = project.purchaseOrderNumber ?? selectedProject.purchaseOrderNumber;
  selectedProject.salesOrderNumber = project.salesOrderNumber ?? selectedProject.salesOrderNumber;
    
  store.dispatch(updateReduxAction("UPDATE_PROJECT_MANAGEMENT", {selectedProject: selectedProject}));
  return;
}
//Update project based on user changes in the edit project modal dialog.
export async function updateProjectInDatabase(project:any){
  updateSelectedProject(project);
  const token = await getAuthToken();

  const editedProjectRequest = {
    //createdById: auth.userId,
    projectName: project.projectName,
    consultingEngineer: project.consultingEngineer,
    contractor: project.contractor,
    city: project.city,
    state: project.state,
    projectId:project.id,
    jobPhase:project.jobPhase,
    projectType:project.projectType,
    constructionType:project.constructionType,
    buildingType:project.buildingType,
    designBasis:normalizeBasisOfDesign(project.designBasis),
    purchaseOrderNumber:project.purchaseOrderNumber,
    salesOrderNumber:project.salesOrderNumber
  };
 
  const result = await fetch(apibase + '/dataapi/updateProject', {
    method: 'post',
    body: JSON.stringify(editedProjectRequest),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'updateProject');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

export async function addNewProject(reduxProjectManagement: any) {
  const token = await getAuthToken();
  const userInfo: IUserInfo = getUserInfo(getAuth()?.profile);
  const newProjectRequest = {
    projectName: reduxProjectManagement.projectName,
    consultingEngineer:reduxProjectManagement.consultingEngineer ?? "",
    contractor: reduxProjectManagement.contractor ?? "",
    city: reduxProjectManagement.city ?? "",
    state: reduxProjectManagement.state ?? "",
    userId: userInfo.userId,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName,
    userType: userInfo.userType,
    email: userInfo.email,
    jobPhase:reduxProjectManagement.jobPhase,
    projectType:reduxProjectManagement.projectType,
    constructionType:reduxProjectManagement.constructionType,
    designBasis:normalizeBasisOfDesign(reduxProjectManagement.designBasis),
    purchaseOrderNumber:reduxProjectManagement.purchaseOrderNumber,
    salesOrderNumber:reduxProjectManagement.salesOrderNumber
  };
  const result = await fetch(apibase + '/dataapi/createproject', {
    method: 'post',
    body: JSON.stringify(newProjectRequest),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'createProject');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

//Add new unit to the database and projectFileString
export async function addUnit(projectId: number) {
  const token = await getAuthToken();
  let userRole = null;
  // const identityService = new IdentityService();
  // const user = await identityService.getUser();
  // const userInfo: IUserInfo = await identityService.getUserInfo(user);
  const auth = store.getState().reduxAuth;
    if (auth.userRoles?.length > 0) {
      auth.userRoles.forEach((role: any) => {
        if (role === "rep") {
          userRole = "rep";
        }
        if (role === "employee"){
          userRole = "employee";
        }
        if (role === "customer"){
          userRole = "customer";
        }
      });
    }
  const newUnitDto = {
    projectId: projectId,
    userType: userRole
  };
  const result = await fetch(apibase + '/dataapi/createUnit', {
    method: 'post',
    body: JSON.stringify(newUnitDto),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'createUnit');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

export async function getUnits(projectId: any) {
  const token = await getAuthToken();
try{
    const result = await fetch(apibase + '/dataapi/getUnits/' + projectId, {
      method: 'get',
      headers: { Authorization: `Bearer ${token}` }
    });
    if (result.status === 200) {
      const data = await result.json();
      if (data.hasError){
        displayErrorString(data.errorMessage, "getUnits");
      }
      return data;
    }
    else{
      if (!handleUnauthorized(result.status, 'getUnits')) {
        displayErrorString("Requst failed", 'getUnits');
      }
    }
  }
  catch{
    displayErrorString("Requst failed", 'getUnits');
  }
}
export async function cancelFactoryRequest(requestId:number, projectId:string) {
  const token = await getAuthToken();
  const result = await fetch(apibase + '/dataapi/cancelFactoryRequest/' + requestId, {
    method: 'post',
    body: JSON.stringify(projectId),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'cancelFactoryRequest');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  if (response.data.hasError){
    displayErrorString(response.data.errorMessage, "cancelFactoryRequest");
  }
  return response;
}
export async function createFactoryRequest(factoryRequestPayload:any, modificationFile:File[] | null, purchaseOrderFile: File | null, taxExemptFile: File | null) {
  const token = await getAuthToken();

  const formData = new FormData();
  const factoryRequest = JSON.stringify(factoryRequestPayload);
  let totalSizeBytes = 0;
  
  formData.append("factoryRequestPayloadJson", factoryRequest);

  if (modificationFile !== null && modificationFile.length > 0) {
    modificationFile.forEach(file => {
      formData.append("ModificationAttachment", file, file.name);  
      totalSizeBytes += file.size;
    });
  }
  if (purchaseOrderFile !== null) {
    formData.append("PurchaseOrderAttachment", purchaseOrderFile, purchaseOrderFile.name);
    totalSizeBytes += purchaseOrderFile.size;
  }
  if (taxExemptFile !== null) {
    formData.append("TaxExemptAttachment", taxExemptFile, taxExemptFile.name);
    totalSizeBytes += taxExemptFile.size;
  }

  if(totalSizeBytes > MAX_FACTORY_REQUEST_ATTACHMENT_SIZE_MB * 1024 * 1024){
    displayErrorString("Total attachment size exceeds the 50 MB upload limit.", "createFactoryRequest");
    return {success: false, data: null};
  }
  const result = await fetch(apibase + '/dataapi/factoryRequests', {
    method: 'POST',
    body: formData,
    headers: {
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'createFactoryRequest');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  if (response.data.hasError){
    displayErrorString(response.data.errorMessage, "createFactoryRequest");
  }
  return response;
}
export async function getFactoryRequestLogData(projectId: string) {
  const token = await getAuthToken();
  const result = await fetch(apibase + '/dataapi/factoryRequests/project/' + projectId, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getFactoryRequestLogData");
    }
    return data;
  }
  else{
    displayErrorString("Request failed", 'getFactoryRequestLogData');
  }
}
export async function getOutputDocumentsData(projectId: any) {
  const token = await getAuthToken();

  const result = await fetch(apibase + '/dataapi/getOutputDocumentsData/' + projectId, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getOutputDocumentsData");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, 'getOutputDocumentsData')) {
      displayErrorString("Requst failed", 'getOutputDocumentsData');
    }
  }
}
export async function getSelectedUnitPricingDetails(projectId: any) {
  const token = await getAuthToken();

  const result = await fetch(apibase + '/dataapi/getSelectedUnitPricingDetails/' + projectId, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getSelectedUnitPricingDetails");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, 'getSelectedUnitPricingDetails')) {
      displayErrorString("Requst failed", 'getSelectedUnitPricingDetails');
    }
  }
}
export async function getUnitsWithOversizedInfo(projectId: any) {
  const token = await getAuthToken();

  const result = await fetch(apibase + '/dataapi/getUnitsWithOversizedInfo/' + projectId, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getUnitsWithOversizedInfo");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, 'getUnitsWithOversizedInfo')) {
      displayErrorString("Requst failed", 'getUnitsWithOversizedInfo');
    }
  }
}

export async function getUnitsForOutputDocs(projectId: number) {
  const token = await getAuthToken();

  const result = await fetch(apibase + '/dataapi/getUnitsForOutputDocUI/' + projectId, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getUnits");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, 'getUnits')) {
      displayErrorString("Requst failed", 'getUnits');
    }
  }
}

export async function getUnit(routeParams: any) {
  const { unitId } = routeParams;
  const token = await getAuthToken();

  const result = await fetch(apibase + '/dataapi/getUnit/' + unitId, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getUnit");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, 'getUnit')) {
      displayErrorString("Requst failed", 'getUnit');
    }
  }
}
//Copy a unit - call goes directly to ProjectDataAPI
export async function copyUnit(sourceProjectId:string, targetProjectId:string, unitTagName:string, unitId:number) {
  const token = await getAuthToken();

  const newUnitRequest = {
    sourceProjectId: sourceProjectId,
    targetProjectId: targetProjectId,
    unitId: unitId,
    unitTag: unitTagName
  };
  const result = await fetch(apibase + '/dataapi/copyUnit', {
    method: 'post',
    body: JSON.stringify(newUnitRequest),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'copyUnit');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

//Copy a Project - call goes directly to ProjectDataAPI
export async function copyProject(projectId:string, projectName:string) {
   const token = await getAuthToken();

  const copyProjectRequest = {
    projectId: projectId,
    projectName: projectName,
  };
  const result = await fetch(apibase + '/dataapi/copyProject', {
    method: 'post',
    body: JSON.stringify(copyProjectRequest),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'copyProject');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

export async function getProjectAndUnitName(projectId: string, unitId: string, appVersion:string) {
  const token = await getAuthToken();
  let targetEndpoint = "dataapi/getProjectAndUnitName";

  const result = await fetch(`${apibase}/${targetEndpoint}/${projectId}/${unitId}/${appVersion}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });

  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "getProjectAndUnitName");
    }
    return data;
  }
  else{
    if (!handleUnauthorized(result.status, 'getProjectAndUnitName')) {
      displayErrorString("Requst failed", 'getProjectAndUnitName');
    }
  }
}

export async function deleteProjectAndUnits(projectId:string){
  const token = await getAuthToken();

  const result = await fetch(apibase + `/dataapi/deleteProject/${projectId}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });

  //result.json = successful object
  //result.text = error message
  handleUnauthorized(result.status, 'deleteProject');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

export async function deleteUnit(projectId:string, unitId:string){
  const token = await getAuthToken();

  const result = await fetch(apibase + `/dataapi/deleteUnit/${projectId}/${unitId}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });

  //result.json = successful object
  //result.text = error message
  handleUnauthorized(result.status, 'deleteUnit');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

export async function updateUnitActiveStatus(projectId:string, unitId:string, newStatus:boolean){
  const token = await getAuthToken();

  const result = await fetch(apibase + `/dataapi/updateUnitActiveStatus/${projectId}/${unitId}/${newStatus}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });

  if (result.status === 200) {
    const data = await result.json();
    if (data.hasError){
      displayErrorString(data.errorMessage, "updateUnitActiveStatus");
    }
    return data;
  }
  else{
    displayErrorString("Request failed", 'updateUnitActiveStatus');
    return {hasError: true, errorMessage: "Request failed"};
  }
}

//---------------------- Project Transfer -----------------------------------

export async function getRepsByOfficeId() {
  const token = await getAuthToken();
  const userInfo: IUserInfo = getUserInfo(getAuth()?.profile);

  //TODO: Take this out
  // console.log("--------- Calling with hardcoded officeId -----------");
  // console.log(userInfo);
  // let testMembershipArray = [{OfficeName: "testOffice", OfficeId:1239}];

  const req = {
    userId: userInfo.userId,
    repOfficeMemberships: userInfo.officeMembershipsArr
    //repOfficeMemberships: testMembershipArray
  };

  const result = await fetch(apibase + '/dataapi/getContactsByOfficeId', {
    method: 'post',
    body: JSON.stringify(req),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'getContactsByOfficeId');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}

export async function transferProjectToNewUser(projectId: string, selectedUserId:string){
  const token = await getAuthToken();

  const editedProjectRequest = {
    projectId: projectId,
    newOwnerId: selectedUserId
  };
 
  const result = await fetch(apibase + '/dataapi/transferProjectToNewUser', {
    method: 'post',
    body: JSON.stringify(editedProjectRequest),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'transferProjectToNewUser');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}
export async function updateUnitQuantityAndTag(updateRequest:any){
  const token = await getAuthToken();

  const result = await fetch(apibase + '/dataapi/updateUnitQuantityAndTag', {
    method: 'post',
    body: JSON.stringify(updateRequest),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'updateUnitQuantityAndTag');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}
//Save user profile info to sql table.
export async function saveUserIdentity(request:any){
  const token = await getAuthToken();
 
  const result = await fetch(apibase + '/dataapi/saveUserIdentity', {
    method: 'post',
    body: JSON.stringify(request),
    headers: { 'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` }
  });

  //Server side method is Void. No response.

}

